import { BarChart } from "@mui/x-charts";
import { useEffect, useState } from "react";
import Window from "../components/Window/Window";
import useApiRequest from "../hooks/useApiRequest";
import { CircularProgress } from "@mui/material";

const Dashboard = () => {
    // eslint-disable-next-line
    const { data, list, loading } = useApiRequest("/users");
    const [formattedData, setFormatedData] = useState([]);

    useEffect(() => {
        list();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (data?.length > 0) {
            const chartData = data.reduce((acc, item) => {
                const date = new Date(item.created_at).toLocaleDateString();
                if (!acc[date]) {
                    acc[date] = { created_at: date, count: 0 };
                }
                acc[date].count += 1;
                return acc;
            }, {});

            const formattedData = Object.values(chartData).map(
                ({ created_at, count }) => ({
                    x: created_at,
                    y: count,
                })
            );

            setFormatedData(formattedData);
        }
        // eslint-disable-next-line
    }, [data]);

    return (
        <Window title={"Dashboard"}>
            {loading && <CircularProgress />}
            {!loading && (
                <>
                    <BarChart
                        key={1}
                        xAxis={[
                            {
                                dataKey: "x",
                                scaleType: "band",
                            },
                        ]}
                        series={[{ dataKey: "y" }]}
                        width={800}
                        height={500}
                        barLabel="value"
                        barLabelFormatter={(value) => `${value} usuarios`}
                        barLabelStyle={{ fontSize: 12, fill: "white" }}
                        barLabelPosition="top"
                        barLabelOffset={5}
                        dataset={formattedData}
                    />
                    <div
                        style={{
                            marginTop: "20px",
                            fontSize: "16px",
                            fontWeight: "bold",
                            color: "white",
                        }}
                    >
                        Total de usuarios: {data?.length}
                    </div>
                </>
            )}
        </Window>
    );
};

export default Dashboard;
